<template>
  <div>
    <Head title="Dërgesat"/>

    <h1 class="mb-8 text-3xl font-bold">Dërgesat</h1>

    <div class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/4 mt-4 mb-4 lg:-mb-4">
      <input class="relative border px-6 py-3 w-full rounded focus:shadow-outline mt-3 lg:mt-0" autocomplete="off" type="text" placeholder="Kërko me ID"  v-model="form.id"/>
    </div>

    <div class="flex flex-wrap lg:flex-nowrap mb-6 items-center justify-between">

      <div  class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/2 -mb-4">

        <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
          <label class="block text-gray-700">Biznesi shitës:</label>
          <select v-model="form.business_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option v-for="business in businesses" :value="business.id">{{ business.name }}</option>
          </select>

          <label class="block text-gray-700">Pika marrëse:</label>
          <select v-model="form.location_id" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option v-for="location in selectedLocations" :value="location.id">{{ location.name }}</option>
          </select>

          <label class="block mt-4 text-gray-700">Likuiduar:</label>
          <select v-model="form.barazuar" class="form-select mt-1 w-full">
            <option :value="null">Të gjitha</option>
            <option value="true">Po</option>
            <option value="false">Jo</option>
          </select>
        </search-filter>
      </div>
      <!--      <Link class="btn-indigo" :href="route('admin.orders.template')">-->
      <!--        <span>Excel</span>-->
      <!--      </Link>-->
      <div class="flex flex-wrap items-end space-y-4 lg:space-y-0 -mb-8 lg:-mb-4 py-8">

        <Link class="btn-indigo mr-3" :href="route('seller.orders.create')">
          <span>Regjistro</span>
          <span class="hidden md:inline"> Dërgesë të re</span>
        </Link>

        <button type="button" class="btn-indigo bg-green-600 mr-3"  @click="showExcelModal = true">Regjistro me Excel</button>

        <Teleport to="body">
          <!-- use the modal component, pass in the prop -->
          <modal :show="showExcelModal" @close="showExcelModal = false">
            <template #header>
              <h3>Regjistro dërgesat me Excel file.</h3>
            </template>

            <template #body>

              <div class="flex flex-wrap">
                <a type="button" class="px-4 my-3 py-1 items-center text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm"  :href="route('seller.orders.template')" download>Shkarko formatin</a>

                <file-input v-model="excelForm.excel_file" :error="excelForm.errors.excel_file" class="w-full pb-4" type="file" accept="xlsx/*" label="Ngarko fajllin ne Excel" />
              </div>
            </template>

            <template #footer>
              <div class="flex flex-wrap">
                <loading-button class="btn-indigo bg-red-500"
                                @click = "showExcelModal = false"
                >Anulo</loading-button>
                <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="button" @click="bulkRegister(); showExcelModal = false">Regjistro</loading-button>
              </div>
            </template>
          </modal>
        </Teleport>

        <a :href="route('seller.orders.excel',this.form)" download class="pb-1"><icon name="excel"></icon></a>

      </div>
    </div>


    <div class="flex flex-wrap  mb-6 lg:mb-6">

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label text-gray-700">Statusi:</label>
        <!--        <select multiple v-model="form.status_id" class="form-select focus:ring-0 hover:border-indigo-500">-->
        <!--          <option :value="null">Të gjitha</option>-->
        <!--          <option v-for="status in statuses" :value="status.id">{{ status.name }}</option>-->
        <!--        </select>-->
        <Multiselect
          v-model="form.status_ids"
          :options="filterStatuses.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />

      </div>

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label">Shteti:</label>
        <Multiselect
          v-model="form.country_ids"
          :options="filterCountries.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/5">
        <label class="form-label">Qyteti:</label>
        <Multiselect
          v-model="form.city_ids"
          :options="filterCities.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>


      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e regjistrimit:</label>
        <input v-model="form.start_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>


      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e ndryshimit të statusit:</label>
        <input v-model="form.start_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data e likuidimit:</label>
        <input v-model="form.start_date_barazuar" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date_barazuar" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

    </div>

    <div v-if="currentSelections != null && currentSelections.length !== 0" class="flex flex-wrap lg:flex-nowrap mb-6 lg:mb-3 items-center">
      <dropdown class="mt-1" placement="bottom-end">
        <template #default>
          <icon name="print" class="mr-2 w-6 h-6"></icon>
        </template>
        <template #dropdown>
          <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
            <a type="button" :href="route('seller.print.order.pdf.multiple',{orderIds: currentSelections})" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" target="_blank">Printo PDF</a>
            <!-- Only for Pinguiniretail  --><a v-if="user.id === 27" type="button" :href="route('seller.print.order.pdf.multiple',{orderIds: currentSelections, printFull:true})" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" target="_blank">Printo PDF (të plotë)</a>
            <a type="button" :href="route('seller.print.order.sticker.8x5.multiple',{orderIds: currentSelections})" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" target="_blank">Printo Stiker 8x5cm</a>
            <a type="button" :href="route('seller.print.order.sticker.10x7.multiple',{orderIds: currentSelections})" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" target="_blank">Printo Stiker 10x7cm</a>
          </div>
        </template>
      </dropdown>

    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">
            <input :checked="allSelected" @click="selectAll" class="flex items-center  px-2 py-4" type="checkbox">
          </th>
          <th class="pb-4 pt-6 px-2"></th>
          <th @click="sort('id')" class="pb-4 pt-6 px-2 cursor-pointer">ID</th>
          <th @click="sort('custom_id')" class="pb-4 pt-6 px-2 cursor-pointer">ID e juaj</th>
          <th @click="sort('status_id')" class="pb-4 pt-6 px-2 cursor-pointer">Statusi</th>
          <th @click="sort('business_name')" class="pb-4 pt-6 px-2 cursor-pointer">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-2">Pika marrëse</th>
          <th @click="sort('name')" class="pb-4 pt-6 px-2 cursor-pointer">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-2">Telefoni i blerësit</th>
          <th @click="sort('product_name')" class="pb-4 pt-6 px-2 cursor-pointer">Produkti</th>
          <th @click="sort('quantity')" class="pb-4 pt-6 px-2 cursor-pointer">Sasia</th>
          <th @click="sort('package_size_id')" class="pb-4 pt-6 px-2 cursor-pointer">Madhësia e pakos</th>
          <th @click="sort('product_price')" class="pb-4 pt-6 px-2 cursor-pointer">Çmimi</th>
          <th @click="sort('shipping_price')" class="pb-4 pt-6 px-2 cursor-pointer">Posta</th>

          <th @click="sort('city_name')" class="pb-4 pt-6 px-2 cursor-pointer">Qyteti</th>
          <th @click="sort('hr_created_at')" class="pb-4 pt-6 px-2 cursor-pointer">Krijuar më</th>
          <th @click="sort('updated_status_at')" class="pb-4 pt-6 px-2 cursor-pointer">Statusi edituar më</th>
          <th @click="sort('barazuar_at')" class="pb-4 pt-6 px-2 cursor-pointer">Likuiduar më</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="order in sortedOrders" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-2">
            <input v-model="order.selected" :value="order.id" class="flex items-center  px-2 py-4" type="checkbox">
          </td>

          <td class="w-px border-t">
            <Link class="flex items-center  px-2 py-4" :href="`dergesat/${order.id}`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              <icon v-if="order.barazim_id" name="paid" class="flex-shrink-0 ml-2 w-5 h-5 fill-gray-400" />
            </Link>
          </td>

          <td class="border-t px-2">
              {{ order.id }}
              <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              <small v-if="order.is_change" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">NDËRRIM</small>
              <small v-if="order.is_cash && order.has_product" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">CASH</small>
              <small v-if="order.is_recreated" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">RINISJE</small>
              <small v-if="order.parent_id" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">BASHKIM</small>
              <small v-if="order.from_api" class="mx-0.5 px-2 py-1 rounded-md bg-gray-400">API</small>

          </td>
          <td class="border-t px-2">
              {{ order.custom_id }}
          </td>
          <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getStatusColor(order.status.id)">
                {{ order.status.name }}</span>
          </td>
          <td class="border-t px-2">
              {{ order.business.name }}
          </td>
          <td class="border-t px-2">
              {{ order.location.name }}
          </td>
          <td class="border-t px-2">
              {{ order.name }}
          </td>
          <td class="border-t px-2">
              {{ order.phone }}
          </td>
          <td class="border-t px-2">
              {{ order.product_name }}
          </td>
          <td class="border-t px-2">
              {{ order.quantity }}
          </td>
          <td class="border-t px-2">
              {{ order.package_size.name }}
          </td>
          <td class="border-t px-2">
              {{ order.product_price }}
          </td>
          <td class="border-t px-2">
              {{ order.shipping_price }}
          </td>

          <td class="border-t px-2">
              {{ order.city.name }}
          </td>
          <td class="border-t px-2">
              {{ order.hr_created_at }}
          </td>
          <td class="border-t px-2">
            {{ order.updated_status_at }}
          </td>
          <td class="border-t px-2">
            {{ order.barazuar_at }}
          </td>

          <td class="w-px border-t">

            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <icon name="three-dots" class="block w-12 h-6 fill-gray-400"/>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`shites/print/${order.id}/pdf`" target="_blank">Printo</a>
                  <!-- Only for Pinguiniretail  --><a v-if="user.id === 27"  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`shites/print/${order.id}/pdf?printFull=true`" target="_blank">Printo(të plotë)</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.print.order.sticker.8x5',{order: order.id})" target="_blank">Printo Stiker 8x5cm</a>
                  <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('seller.print.order.sticker.10x7',{order: order.id})" target="_blank">Printo Stiker 10x7cm</a>
                  <Link v-if="order.status.id === 1" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`dergesat/${order.id}/edit`">Edito</Link>
                  <button v-if="!order.deleted_at && order.status.id === 1" class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" tabindex="-1" type="button" @click="destroy(order.id)">Fshij</button>

                </div>
              </template>
            </dropdown>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje dërgesë.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-wrap">
      <select-input v-model="form.per_page"  class="p-0 mt-6 mr-5 w-1/4 lg:w-1/12"
      >
        <option v-if="orders.meta.total > 15" value="15">15 / {{orders.meta.total}}</option>
        <option v-if="orders.meta.total > 30"  value="30">30 / {{orders.meta.total}}</option>
        <option v-if="orders.meta.total > 50"  value="50">50 / {{orders.meta.total}}</option>
        <option v-if="orders.meta.total > 100"  value="100">100 / {{orders.meta.total}}</option>
        <option :value="orders.meta.total">{{orders.meta.total}} / {{orders.meta.total}}</option>
      </select-input>
      <pagination class="mt-6" :links="orders.meta.links"/>
    </div>  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import axios from 'axios'
import Dropdown from '@/Shared/Dropdown'
import {computed} from 'vue'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchInput,
    SearchFilter,
    Dropdown,
    FileInput,
    Modal,
    LoadingButton,
    SelectInput,
    Multiselect
  },
  layout: Layout,
  props: {
    orders: Object,
    filters: Object,
    countries: Object,
    cities: Object,
    locations: Object,
    businesses: Object,
    statuses: Object
  },
  data() {
    return {
      excelForm: this.$inertia.form({
        excel_file: null
      }),
      form: {
        id: this.filters.id,
        search: this.filters.search,
        barazuar: this.filters.barazuar,
        country_ids: this.filters.country_ids,
        city_ids: this.filters.city_ids,
        location_id: this.filters.location_id,
        business_id: this.filters.business_id,
        status_ids: this.filters.status_ids,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        start_date_status_updated: this.filters.start_date_status_updated,
        end_date_status_updated: this.filters.end_date_status_updated,
        start_date_barazuar: this.filters.start_date_barazuar,
        end_date_barazuar: this.filters.end_date_barazuar,
        per_page: this.orders.meta.total < 15 ? this.orders.meta.total : this.orders.meta.per_page
      },
      filterStatuses: {
        options: this.statuses.map(function(status){
          return {value: status.id, label: status.name}
        }),
      },
      filterCountries: {
        options: this.countries.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterCities: {
        options: this.cities.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      selectedCities: this.cities,
      selectedLocations: this.locations,
      showExcelModal: false,
      currentSelections: null,
      currentSort: null,
      currentSortDir: 'asc'
    }
  },
  mounted() {
    this.orders.data.forEach((order) => order['selected'] = false);
  },
  computed:{
    allSelected(){
      return this.orders.data.every(order => order.selected)
    },
    sortedOrders(){
      return this.orders.data.sort((a,b) => {
        if(this.currentSort == null) return 0;
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;

        if(!isNaN(a[this.currentSort])){
          if(parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort])) return -1 * modifier;
          if(parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort])) return modifier;
          return 0;
        }

        if((a[this.currentSort] != null ? a[this.currentSort].toLowerCase(): '') < (b[this.currentSort] != null ? b[this.currentSort].toLowerCase() : '')) return -1 * modifier;
        if((a[this.currentSort] != null ? a[this.currentSort].toLowerCase() : '') > (b[this.currentSort] != null ? b[this.currentSort].toLowerCase() : '')) return modifier;
        return 0;
      });
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/dergesat', pickBy(this.form), {preserveState: true})
      }, 150),
    },
    orders: {
      handler() {
        this.currentSelections = this.orders.data
          .filter( order => order.selected )
          .map( order => order.id )
          .toString();
      },
      deep: true
    },
    'form.country_id'(){
      this.getCities()
    },
    'form.business_id'(){
      this.getLocations()
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  methods: {
    bulkRegister(){
      this.excelForm.post(`/dergesat/excel`)
    },
    destroy(orderId) {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/dergesat/${orderId}`)
      }
    },
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    selectAll(){
      let allS = this.allSelected;
      this.orders.data.forEach(order => order.selected = !allS)
    },
    sort(sortBy) {
      if(sortBy === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = sortBy;
    },
    getCities(){
      let self = this
      self.selectedCities = []
      axios.get('/ajax/list/cities',{
        params: {
          country_id: this.form.country_id,
        }
      }).then(function (result){
        self.selectedCities = result.data.cities;
      });
    },
    getLocations(){
      let self = this
      self.selectedLocations = []
      axios.get('/ajax/list/locations',{
        params: {
          business_id: this.form.business_id,
        }
      }).then(function (result){
        self.selectedLocations = result.data.locations;
      });
    },
    getStatusColor(orderId){
      let statusColor = 'bg-indigo-500'
      if(orderId === 1)
        statusColor = 'bg-yellow-500'

      if(orderId === 3)
        statusColor = 'bg-orange-500'

      if(orderId === 4)
        statusColor = 'bg-indigo-900'

      if(orderId === 5)
        statusColor = 'bg-green-500'

      if(orderId === 6)
        statusColor = 'bg-yellow-700'

      if(orderId === 7)
        statusColor = 'bg-red-500'

      if(orderId === 8)
        statusColor = 'bg-gray-400'

      if(orderId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    }
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
